import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";

export default function Types() {
  const { t, lang } = useLang();
  const [types, setTypes] = useState([]);
  const suffix = lang === "hi" ? "Hi" : lang === "ta" ? "Ta" : "";
  const pick = (obj, base) => obj[base + suffix] || obj[base];

  useEffect(() => {
    api.get("/api/archetypes").then((r) => setTypes(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 py-14" data-testid="types-page">
      <h1 className="font-display text-4xl font-semibold sm:text-5xl" data-testid="types-title">{t("types.title")}</h1>
      <p className="mt-3 text-base text-muted-foreground md:text-lg">{t("types.sub")}</p>
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {types.map((a) => (
          <div key={a.key} className="rounded-2xl border border-border bg-card p-6 transition-all hover:-translate-y-1 hover:shadow-lg" data-testid={`type-card-${a.key}`}>
            <span className="inline-block h-3 w-10 rounded-full" style={{ backgroundColor: a.color }} />
            <h3 className="font-display mt-4 text-lg font-semibold">{pick(a, "name")}</h3>
            <p className="mt-1 text-xs font-medium text-muted-foreground">{pick(a, "tagline")}</p>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{pick(a, "description")}</p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {(lang === "ta" && a.areasTa ? a.areasTa : a.areas).map((ar) => (
                <span key={ar} className="rounded-full bg-secondary px-2 py-0.5 text-[11px] font-medium text-secondary-foreground">{ar}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <Link to="/signup"><Button size="lg" className="rounded-full px-8" data-testid="types-cta">{t("hero.cta.test")}</Button></Link>
      </div>
    </div>
  );
}
